import React, { useEffect, useState } from 'react';
import { NCZIEntry } from '../../../../Interfaces/ncziTypes';
import { joinClasses } from '../../../../../../Utils/className.util';
import EHREntryInfo from '../../../EHR/EHRExtract/EHREntry/EHREntryInfo';
import LinkButton from '../../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../../Enums/Theme.enum';
import Text from '../../../../../../Components/Base/Text/Text';
import Tag from '../../../../../../Components/Tag/Tag';

// @ts-ignore
import styles from './ElectronicExaminationVLSearchResultItem.module.scss';
import EHREntryModal from '../../../EHR/EHRExtract/EHROpenableEntry/EHREntryModal';

interface Props {
	item: NCZIEntry;
	patientIdentifier: string;
	onCloseDetail?: (needReload: boolean) => void;
}

const ElectronicExaminationVLSearchResultItem: React.FC<Props> = props => {
	const { item, patientIdentifier, onCloseDetail } = props;
	const [entryOpened, setEntryOpened] = useState<boolean>(false);

	const handleCloseDetailModal = (needReload: boolean = false) => {
		setEntryOpened(false);
		if(needReload) {
			onCloseDetail?.(needReload);
		}
	};

	const isCancelled = item.info?.version === 'VER04';

	return (
		<>
			<div
				className={joinClasses([
					styles.wrapper,
					isCancelled ? styles.cancelled : undefined,
				])}>
				<div className={styles.border}>
					<div className={styles.content}>
						<div className={styles.header}>
							<div className={styles.openEntryName}>
								<Text tx={item?.name} className={joinClasses([isCancelled ? styles.cancelledTitle : ''])} />
								{isCancelled && <Tag
									label={'nczi.cancelled'}
									className={styles.cancelledTag}
								/>}
							</div>
						</div>
						<EHREntryInfo info={item.info} />
					</div>
					<div className={styles.controls}>
						<LinkButton
							title={'nczi.showDetails'}
							theme={Theme.BLUE}
							onClick={() => setEntryOpened(true)}
						/>
					</div>
				</div>
			</div>
			<EHREntryModal opened={entryOpened} onClose={handleCloseDetailModal} entry={item} patientIdentifier={patientIdentifier} />
		</>
	);
};

export default ElectronicExaminationVLSearchResultItem;
